module.exports = __webpack_public_path__ + "static/media/GC01@m.a602b95b.jpg";